export const styleConfig = {
    partnerEnv: [
      { siteId: "APP_RPLID", styleName: "contactcenter" },
      { siteId: "APP_UCD", styleName: "contactcenter" },
      { siteId: "PLCN_BESTBUY", styleName: "bestbuy" },
      { siteId: "PLCN_BRP", styleName: "brp"},
      { siteId: "PLCN_HOMEDEPOT", styleName: "homedepot" },
      { siteId: "CACN_HOMEDEPOT", styleName: "homedepot_ca" },
      { siteId: "PLCN_GOODYEAR", styleName: "goodyear" },
      { siteId: "GOODYEAR", styleName: "goodyear" },
      { siteId: "PLOC_SHELL", styleName: "shell" },
      { siteId: "PLCN_CTY", styleName: "citithankyou" }, 
      { siteId: "PLCN_BROOKSBROTHERS", styleName: "brooksbrothers" },
      { siteId: "PLOC_EXXONMOBIL", styleName : "exxonmobil"},
      { siteId: "PLOC_SUNOCO", styleName: "sunoco" },
      { siteId: "PLCN_MACYS", styleName: "macys" },
      { siteId: "PLCN_KAWA", styleName: "kawasaki" },
      { siteId: "PLCN_LLBEAN", styleName: "llbean"},
      { siteId: "PLCN_MEIJER", styleName: "meijer"},
      { siteId: "PLCN_WFCC", styleName: "wayfair"},
      { siteId: "PLCN_BRANDSOURCE", styleName: "brandsource"},
      { siteId: "PLCN_JEWELRY", styleName: "jewelersreserve"},
      { siteId: "PLCN_HNPE", styleName: "honda"},
      { siteId: "PLCN_HOME", styleName: "homefurnishing"},
      { siteId: "PLCN_SERVICE", styleName: "ford"},
      { siteId: "PLCN_LINCOLNSERVICES", styleName: "lincoln"},     
      { siteId: "PLCN_COSTCO", styleName: "costco"},
      { siteId: "PLCN_ELECAPPL", styleName: "elecappl"},
      { siteId: "PLCN_AMERICAN", styleName: "americanairlines"},
      { siteId: "PLCN_BLOOMINGDALES", styleName: "bloomingdales" },
      { siteId: "PLOC_WAWA", styleName: "wawa" },
      { siteId: "PLCN_DRIVECARD", styleName: "drivecard" },
      { siteId: "PLCN_TRACTORSUPPLY", styleName: "tractorsupply" },
      { siteId: "PLCN_HNPS", styleName:"hnps"},
      { siteId: "PLCN_CAT", styleName:"caterpillar"},
      { siteId: "PLCN_TORO", styleName: "toro"},
      { siteId: "PLCN_SYW", styleName: "shopyourway"},
      { siteId: "PLCN_STAPLES", styleName: "staples"},
      { siteId: "PLCN_OFFICEDEPOT", styleName: "officedepot" },
      { siteId: "PLCN_CPAY", styleName: "citipay" },
      { siteId: "PLCN_OSTK",   styleName: "overstock"},
      { siteId: "PLCN_DILLARDS",   styleName: "dillards"},
      { siteId: "PLCN_SERVICECENTRAL",   styleName: "tbc"}
    ]
  }
